import { render, staticRenderFns } from "./CompanyHistory.vue?vue&type=template&id=b14b2faa&scoped=true&"
import script from "./CompanyHistory.vue?vue&type=script&lang=js&"
export * from "./CompanyHistory.vue?vue&type=script&lang=js&"
import style0 from "./CompanyHistory.vue?vue&type=style&index=0&id=b14b2faa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14b2faa",
  null
  
)

export default component.exports